import { render, staticRenderFns } from "./LandbotLoader.vue?vue&type=template&id=c7298f48"
import script from "./LandbotLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandbotLoader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LandbotLoader.vue?vue&type=style&index=0&id=c7298f48&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7298f48')) {
      api.createRecord('c7298f48', component.options)
    } else {
      api.reload('c7298f48', component.options)
    }
    module.hot.accept("./LandbotLoader.vue?vue&type=template&id=c7298f48", function () {
      api.rerender('c7298f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/landbot/LandbotLoader.vue"
export default component.exports